import {
    SMS_ROUTES_LOADING,
    SMS_ROUTES_LOADED,
    SMS_ROUTES_CREATED,
    SMS_ROUTES_EDITED,
    SMS_ROUTES_DELETED,
    SMS_ROUTES_FAILED,
    SMS_HEADER_LOADING,
    SMS_HEADER_LOADED,
    SMS_HEADER_CREATED,
    SMS_HEADER_EDITED,
    SMS_HEADER_DELETED,
    SMS_HEADER_FAILED,
    SMSURI_LOADING,
    SMSURI_LOADED,
    SMSURI_EDITED,
    SMSURI_DELETED,
    SMSURI_FAILED,
    SMSURI_CREATED,
    SMSPUSH_LOADING,
    SMSPUSH_SUCCESS,
    SMSPUSH_FAILED,
    SMSPUSH_RESET,
    SMSPUSH_DETAILS_SUCCESS,
    SMSURI_SEARCH,
    SMSPUSH_SUMMARY,
    LOGOUT,
} from '../types';

import {
    created,
    editedUpdate,
    deleteFromState,
} from '../../helpers/reduxUtils';

const initialState = {
    loading: false,
    routes: [],
    smsuri: [],
    smsuriSearch: [],
    headers: [],
    summary: null,
    smspushSuccess: false,
    smsResult: null,
    smsDetails: null,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SMS_HEADER_LOADING:
        case SMS_ROUTES_LOADING:
        case SMSURI_LOADING:
        case SMSPUSH_LOADING:
            return {
                ...state,
                loading: true,
            };
        case SMSURI_SEARCH:
            return {
                ...state,
                loading: false,
                smsuriSearch: action.payload,
            };

        case SMSPUSH_SUMMARY:
            return {
                ...state,
                loading: false,
                summary: action.payload,
            };

        case SMSPUSH_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                smsDetails: action.payload,
            };

        case SMSURI_LOADED:
            return {
                ...state,
                loading: false,
                smsuri: action.payload,
            };
        case SMS_HEADER_LOADED:
            return {
                ...state,
                loading: false,
                headers: action.payload,
            };
        case SMSURI_CREATED:
            return {
                ...state,
                loading: false,
                smsuri: created(state.smsuri, action.payload),
            };
        case SMS_HEADER_CREATED:
            return {
                ...state,
                loading: false,
                headers: created(state.headers, action.payload),
            };
        case SMSURI_EDITED:
            return {
                ...state,
                loading: false,
                smsuri: editedUpdate(state.smsuri, action.payload),
                smsuriSearch: editedUpdate(state.smsuriSearch, action.payload),
            };
        case SMS_HEADER_EDITED:
            return {
                ...state,
                loading: false,
                headers: editedUpdate(state.headers, action.payload),
            };
        case SMSURI_DELETED:
            return {
                ...state,
                loading: false,
                smsuri: deleteFromState(state.smsuri, action.payload),
            };
        case SMS_HEADER_DELETED:
            return {
                ...state,
                loading: false,
                headers: deleteFromState(state.headers, action.payload),
            };

        case SMS_ROUTES_LOADED:
            return {
                ...state,
                loading: false,
                routes: action.payload,
            };
        case SMS_ROUTES_CREATED:
            return {
                ...state,
                loading: false,
                routes: created(state.routes, action.payload),
            };
        case SMS_ROUTES_EDITED:
            return {
                ...state,
                loading: false,
                routes: editedUpdate(state.routes, action.payload),
            };
        case SMS_ROUTES_DELETED:
            return {
                ...state,
                loading: false,
                routes: deleteFromState(state.routes, action.payload),
            };
        case SMSPUSH_SUCCESS:
            return {
                ...state,
                loading: false,
                smspushSuccess: true,
                smsResult: action.payload,
            };
        case SMSPUSH_RESET:
        case SMSPUSH_FAILED:
            return {
                ...state,
                loading: false,
                smspushSuccess: false,
                smsResult: null,
                smsDetails: null,
            };
        case SMS_HEADER_FAILED:
        case SMS_ROUTES_FAILED:
        case SMSURI_FAILED:
            return {
                ...state,
                loading: false,
            };
        case LOGOUT:
            return {
                loading: false,
                routes: [],
                headers: [],
            };
        default:
            return state;
    }
}